import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialYearService {

  className = 'FinancialYearService'

  getFinancialYears(init = -5, end = 5): Observable<any[]> {
    const financialYear: any[] = [];
    for (let index = init; index < end; index++) {
      financialYear.push({ year: moment().year() + (index) });
    }
    return Observable.create(function (observer) {
      observer.next(financialYear);
      observer.complete();
    });
  }

}
